module.exports = __webpack_public_path__ + "img/2019-08-19.8568d0d9.jpg";